import request from "@/utils/followUp/request";

const BASE_URL = "/sysMenu";

// 获取角色菜单
export function getRoleMenuList(query) {
  return request({
    url: `${BASE_URL}/getRoleMenuList`,
    method: "get",
    params: query,
  });
}

// 获取角色菜单
export function geMenuTreeList(query) {
  return request({
    url: `${BASE_URL}/getMenuTree`,
    method: "get",
    params: query,
  });
}
